import { ModalModule } from "ngx-bootstrap/modal";
import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from "@angular/core";
import { WebsocketService } from "src/app/core/services/websocket.service";
import { IndexDBService } from "src/app/core/services/indexDB.service";
import { TabNames, menu_button_map } from "src/app/core/services/constants";
import { MiddlwareService } from "src/app/core/services/middleware.service";
import { ChangeDetectionStrategy } from "@angular/core";

import {
  Menu,
  MenuButton,
  MenuRow,
  Tab,

} from "src/app/core/services/interface";
import { BuilderService } from "src/app/sharedservices/builder.service";
import { ActivatedRoute, Router } from "@angular/router";
import { C } from "@fullcalendar/core/internal-common";

@Component({
  selector: "app-menu-slider",
  templateUrl: "./menu-slider.component.html",
  styleUrls: ["./menu-slider.component.scss"],

})
export class MenuSliderComponent implements OnInit, OnDestroy {
  currentMenuSubscription: any;
  tabNames = TabNames;
  mode;
  mobileViewModeMap;
  inputData;
  image: string;
  tab_image: string;
  start_color: string;
  end_color: string;
  bg_color: string;
  @Input() inputMenu: any;

  fontSmaller = true;
  current_tab: Tab;
  current_menu: Menu;
  data: any;
  max_buttons = 6;
  menu_id: string;
  menu: Menu;
  rowList = {};
  sortedRowList = [];
  buttonList = {};
  sortedButtonList = {};
  menuList = {};
  sortedMenuList = [];
  module = "menu";
  tab: any;
  view: boolean;
  defaultMenu: any;
  noDelete: boolean;

  // grid = [ {row_id:, row_order: buttons:[ {button_id, button_form: , button_style, }] ];
  defaultRow: MenuRow = {
    row_id: "0",
    row_order: 0,
    menu_id: "menu4",
    buttons: [],
  };
  newMenu: boolean;

  defaultButton: MenuButton = {
    button_id: "0",
    row_id: "0",
    button_callback: "0",
    button_style: "0",
    button_style_ios: "0",
    button_form: "empty",
    button_code: "placeholder",
    button_order: 0,
    info: { min_grid: 10 },

  };
/// colors to be common into the tab section///
light: boolean = true;
colors: any;
color_schema: any;
color_schema_ios: any;
component_id: string;

row: MenuRow;
button: MenuButton

  constructor(
    private ws: WebsocketService,
    private mdw: MiddlwareService,
    public indexDBService: IndexDBService,
    public ref: ChangeDetectorRef,
    public builderService: BuilderService,
    private router: Router

  ) {}

  ngOnInit() {

    this.component_id = "menu_slider"

    this.currentMenuSubscription = this.mdw.currentMenuContainer$.subscribe(
      (data) => {
        if (data && data["sortedMenuList"] && this.inputMenu && !data["next"] && data["menu"].menu_group == this.inputMenu.menu_group && data['component_id']!=this.component_id) {
          this.current_menu = data["menu"];
          this.inputData = data;
          this.menu = this.current_menu;
          this.menuList = this.inputData["menuList"];
          this.sortedMenuList = this.inputData["sortedMenuList"];
          this.rowList = this.inputData["rowList"];
          this.sortedRowList = [...this.inputData["sortedRowList"]];
          this.buttonList = this.inputData["buttonList"];
          this.sortedButtonList = this.inputData["sortedButtonList"];
          this.defaultRow = this.inputData["defaultRow"];
          this.defaultButton = this.inputData["defaultButton"];
          this.max_buttons = this.inputData["max_buttons"];
          this.module = this.inputData["module"];
          this.mode = localStorage.getItem("mode");
          this.defaultMenu = this.sortedMenuList[0];
          this.tab = this.inputData["tab"];
          if (data['colors']){
            this.colors = data["colors"];
            this.light = data["light"];
        }
      }}
    );

  }

  menuDuplicate(id){
 if (!id){
      return;
     }

  }

  async deleteMenuItem(id) {
     if (!id){
      return;
     }
      this.view = true;
      // multiple menus
      // re-set as default if deleted is a default.
      if (this.sortedMenuList.length > 1) {

        // remove menu from sortedmenuList
        let index = this.sortedMenuList.findIndex((e) => e.menu_id == id);
        // this.sortedMenuList.splice(index, 1);
        this.sortedMenuList = [...this.sortedMenuList.slice(0, index), ...this.sortedMenuList.slice(index + 1)];

        // set current menu. The current menu is not necessary to be the default menu.
        // Defualt menu is the menu where the tab points to
        // set first menu in the list as current menu.

        // this.current_menu = this.sortedMenuList[0];
        this.current_menu = { ...this.sortedMenuList[0] };
        // this.current_menu.menu_id = this.sortedMenuList[0].menu_id; //set next menu as current.
        this.menu = this.current_menu;


      const updatedMenuList = { ...this.menuList };
      delete updatedMenuList[id];
      this.menuList = updatedMenuList;

        // delete this.menuList[id];

        /// reorder the sortedMenuList
        let tempList = this.sortedMenuList;
        let menuOrder = 1

        tempList.forEach((menu) => {
          if (menu.menu_id == this.menu.menu_id){
              menu.menu_order = 0;
              this.menuList[menu.menu_id].menu_order = 0;
          }else {
            menu.menu_order = menuOrder;
            this.menuList[menu.menu_id].menu_order = menuOrder;
            menuOrder++;
          }
            const inputData = { ...menu };
            const response = this.indexDBService.updateItem("menu", inputData);

          });

          this.sortedMenuList= this.sortMenus(tempList);

        //  if deleted is the default, set the current menu as default. Note it is always the index =0 is the default as defination
        if (index == 0) {
          this.tab.menu_id = this.menu.menu_id;
          this.view = false;
        }
        delete this.current_menu["tab"];
        // actual delete the menu from database.
        await this.deleteMenu(id);

        // get the new menu.
        let menu = await this.mdw.constructMenuSync(
            this.current_menu.menu_id
          );
          this.extractMenu(menu);
          delete this.current_menu["rows"];

      } else {
        // single menu only
        await this.deleteRows(id);
        this.sortedMenuList[0].rows = []; //set next menu as default.
        this.current_menu.rows = [];
        this.rowList = {};
        this.buttonList = {};
        this.sortedRowList = [];
        this.sortedButtonList = {};
      }

       let menuData = {};
      menuData["menu"] = this.menu;
      menuData["sortedMenuList"] = this.sortedMenuList;
      menuData["menuList"] = this.menuList;

      menuData["rowList"] = this.rowList;
      menuData["sortedRowList"] = this.sortedRowList;
      menuData["buttonList"] = this.buttonList;
      menuData["sortedButtonList"] = this.sortedButtonList;

      menuData["defaultRow"] = this.defaultRow;
      menuData["defaultButton"] = this.defaultButton;
      menuData["max_buttons"] = this.max_buttons;
      menuData["module"] = this.module;
      menuData["mode"] = this.mode;
      menuData["tab"] = this.tab;
      menuData["colors"] = this.colors
      menuData["light"] = this.light;


      // this.mdw._currentTabContainer.next(data); // to draw the slider

      this.mdw.changeTab(
        { tab: this.tab, menu: this.menu },
        this.module,
        this.view
      );

      // let tabData = {current_tab:this.tab, menu:this.menu}
    // this.mdw._currentTabContainer.next(tabData)
      this.mdw._currentMenuContainer.next(menuData); // to update menupages


  }

  extractMenu(menu: any) {
    this.rowList = {};
    menu.rows.forEach((row: any) => {
      this.rowList[row.row_id] = row;
    });

    this.buttonList = {};
    this.sortedRowList = [];
    this.sortedButtonList = {};
    this.sortedRowList = this.sortRows(Object.values(this.rowList));

    this.sortedRowList.forEach((row: any) => {
      if (row.buttons) {
        row.buttons.forEach((button: any) => {
          this.buttonList[button.button_id] = button;
          this.buttonList[button.button_id].row_id = row.row_id;
          this.sortedButtonList[row.row_id] = (
            this.sortedButtonList[row.row_id] || []
          ).concat([button]);
        });
      }
    });

    Object.values(this.sortedButtonList).forEach((row: any) => {
      if (row.length > 1) {
        this.sortedButtonList[row[0].row_id] = this.sortButtons(
          this.sortedButtonList[row[0].row_id]
        );
      }
    });
  }
  // delete menu should be a service function. and moved out from here  Hazem
  async deleteRows(menu_id) {
    let menu = await this.mdw.constructMenuSync(menu_id);
    menu.rows.forEach((row) => {
      row.buttons.forEach((button) => {
        if (button.row_id == row.row_id) {


          if (button&& button.next && button.next[0] && button.next[0].type=="tab" && button.next[0].id){
                const deleteTab = this.indexDBService.deleteItemBykey(
              "tab",
              button.next[0].id
            );
          }


          const deletereq = this.indexDBService.deleteItemBykey(
            "button",
            button.button_id
          );
        }
      });
      const deletereq = this.indexDBService.deleteItemBykey("row", row.row_id);
    });
  }
  async deleteMenu(menu_id) {
    let menu = await this.constructMenus(menu_id);
    menu.rows.forEach((row) => {
      row.buttons.forEach((button) => {
        if (button.row_id == row.row_id) {

          if (button&& button.next && button.next[0] && button.next[0].type=="tab" && button.next[0].id){
                const deleteTab = this.indexDBService.deleteItemBykey(
              "tab",
              button.next[0].id
            );
          }

          const deletereq = this.indexDBService.deleteItemBykey(
            "button",
            button.button_id
          );
        }
      });
      const deletereq = this.indexDBService.deleteItemBykey("row", row.row_id);
    });
    const deletereq = this.indexDBService.deleteItemBykey("menu", menu_id);
  }

  async constructMenus(query) {
    return await this.indexDBService
      .getItemOnsucss("menu", query)
      .then(async (menuResponse: any) => {
        let menu = menuResponse;
        menu.rows = await this.constructMenuRows(menu.menu_id);
        return menu;
      });
  }

  async constructMenuRows(menuId) {
    return await this.indexDBService
      .getItemListOnsucss("row", "menu", menuId)
      .then(async (rowResponse: any) => {
        let rows = await this.sortRows(rowResponse);

        for (let i = 0; i < rows.length; i++) {
          let newRow = rows[i];
          newRow.buttons = await this.constructMenuRowButtons(rows[i].row_id);
        }
        return rows;
      });
  }

  async constructMenuRowButtons(rowId) {
    return await this.indexDBService
      .getItemListOnsucss("button", "row", rowId)
      .then(async (buttonResponse: any) => {
        let buttons = await this.sortButtons(buttonResponse);
        return buttons;
      });
  }

  sortRows(rows: any[]) {
    return rows.sort((a, b) => Number(a.row_order) - Number(b.row_order));
  }
  sortButtons(buttons: any[]) {
    return buttons.sort(
      (a, b) => Number(a.button_order) - Number(b.button_order)
    );
  }

  sortMenus(menus: Menu[]) {
    return menus.sort((a, b) => Number(a.menu_order) - Number(b.menu_order));

    // Hazem needs to populate the menu_order in order for this function to work.
  }

  async selectMenu(menu_id) {
    this.newMenu = false;
    let index = this.sortedMenuList.findIndex((e) => e.menu_id == menu_id);
    // let current_menu = this.sortedMenuList[index];

    if (index !== -1) {
      this.current_menu = { ...this.sortedMenuList[index] }; // ✅ Creates a new object reference
    }

    if (this.menu && this.current_menu.menu_id != this.menu.menu_id) {
      this.newMenu = true;
    }

    // this.menu = this.current_menu;
    let menuData: any = {};

    menuData["menu"] = this.current_menu;
    menuData["sortedMenuList"] = this.sortedMenuList;
    menuData["menuList"] = this.menuList;


    if (this.newMenu) {
      let menu = await this.mdw.constructMenuSync(this.current_menu.menu_id);
      this.extractMenu(menu);
      delete this.current_menu["rows"];

      menuData["rowList"] = this.rowList;
      menuData["sortedRowList"] = this.sortedRowList;
      menuData["buttonList"] = this.buttonList;
      menuData["sortedButtonList"] = this.sortedButtonList;
      menuData["defaultRow"] = this.defaultRow;
      menuData["defaultButton"] = this.defaultButton;
      menuData["max_buttons"] = this.max_buttons;
      menuData["module"] = this.module;
      menuData["mode"] = this.mode;
      menuData["tab"] = this.tab;
      menuData["colors"] = this.colors
      menuData["light"] = this.light;
      // menuData["component_id"] = this.component_id;

      this.mdw.changeTab(
        {
          tab: { module: this.module, type: 'menu', menu_id: this.current_menu.menu_id },
          menu: this.current_menu,
        },
        this.mode,
        true
      );

      // let tabData = { current_tab: this.tab, menu: this.menu };
      // this.mdw._currentTabContainer.next(tabData);

      this.mdw._currentMenuContainer.next(menuData);
    }
    this.mdw._menuIDContainer.next(menu_id);
    if (this.menu.cat == "splash" && !this.router.url.includes("/" + 'splash')) {
      this.router.navigate([
        "appbuilder/" + window.location.pathname.split("/").pop() + "/splash/" + this.menu.menu_group,]);

    }

  }

  async duplicateMenu(menu){
    let menus = await this.mdw.constructMenuSync(menu.menu_id);
    const cloned = JSON.parse(JSON.stringify(menus));
    let newMenu = await this.updateMenuIds(cloned);
    const clonedNew = JSON.parse(JSON.stringify(newMenu));
    await this.mdw.menusInsertion([clonedNew]);
    // setTimeout(() => {
    this.addNewMenu(newMenu);
    // }, 500);
    // setTimeout(() => {
    this.selectMenu(newMenu.menu_id);
    // }, 1000);
  }

  updateMenuIds(menu: any) {
    // generate new menu_id
    const newMenuId = this.mdw.makeRef(16);
    menu.menu_id = newMenuId;
    menu.menu_ref = newMenuId;
    menu.menu_version = this.mdw.makeRef(16);
    menu.rows = menu.rows.map((row: any) => {
      const newRowId = 'r_' + this.mdw.makeRef(16);

      row.row_id = newRowId;
      row.menu_id = newMenuId;
      row.row_version = newRowId;

      row.buttons = row.buttons.map((btn: any) => {
        const newButtonId = 'b_' + this.mdw.makeRef(16);

        btn.button_id = newButtonId;
        btn.button_callback = newButtonId; // لو مرتبط بيه
        btn.row_id = newRowId;
        btn.button_version = this.mdw.makeRef(16);

        return btn;
      });

      return row;
    });

    return menu;
  }

   addNewMenu(m) {
    let menu_id = this.mdw.makeRef(15);
    let menu: any;
    menu = {...m};
    this.menu = menu;
    this.menuList[menu.menu_id] = menu;

    let tempList = this.sortedMenuList;
    tempList.push(menu);

    let menu_order = 0;
    tempList.forEach((tmenu) => {
      menu.menu_order = menu_order;
      if (menu.menu_id== this.menu.menu_id){
        let prefix = this.current_menu.cat;
        menu.menu_name= this.mdw.generateOrdinalName(menu_order) + prefix
      }
      this.menuList[menu.menu_id].menu_order = menu_order;
      const inputData = { ...menu };
      // console.log(inputData);
      this.indexDBService.updateItem("menu", inputData);
      menu_order++;
    });

    let menuData: any = {};

    this.sortedMenuList = tempList;
    // let sortedbuttonList = {};
    // let buttonList = {};
    // menu.rows.forEach((row) => {
    //   sortedbuttonList[row.row_id] = row.buttons;
    //   row.buttons.forEach((button) => {
    //     buttonList[button.button_id] = button;
    //   });
    // })
    menuData["rowList"] = {};
    menuData["sortedRowList"] = [];
    menuData["buttonList"] = {};
    menuData["sortedButtonList"] = [];

    ///////////////// Add row and button for Splash only /////////////////////
    if (this.tab.module == TabNames.SPLASH) {
      /// create new row and button
      let row_id = "r_" + this.mdw.makeRef(15);
      let button_id = "b_" + this.mdw.makeRef(15);

      // add row
      let newRow = { ...structuredClone(this.defaultRow) };
      newRow.row_id = row_id;
      newRow.row_version = row_id;
      newRow.row_order = 0;
      newRow.menu_id = menu_id;
      newRow.row_lock = true;

      // add button
      let newButton: any = {};
      let button_style = "splash_"+ this.tab.param.splash.style

      newButton = structuredClone(menu_button_map[button_style]);
      // get it per template when switching //
      // newButton.button_img_url = null;
      // newButton.button_bgimage=null;
      // newButton.button_bgstart=null;
      // newButton.button_bgend =null;

      // get it per template when switching //
      newButton.button_img_url = null;
      newButton.button_img_urlSet = null;
      newButton.button_images = { '01':{url:null}, 'default': {url: null} };
      newButton.button_bgimage = null;
      newButton.button_bgimageSet = null;
      newButton.button_bgstart = null;
      newButton.button_bgend = null;
      newButton.button_label = null;

      /////////////////////////////////////

      newButton.button_id = button_id;
      newButton.button_version = button_id;
      newButton.row_id = row_id;
      newButton.button_callback = button_id;
      newButton.button_order = 0;

      this.row = newRow;
      this.button = newButton;

      menuData["rowList"][row_id] = { ...newRow };
      menuData["sortedRowList"] = [...menuData["sortedRowList"], menuData["rowList"][row_id]];
      menuData["buttonList"][button_id] = { ...newButton };
      menuData["sortedButtonList"][row_id] = [];
      menuData["sortedButtonList"][row_id] = [...menuData["sortedButtonList"][row_id], newButton];
      menuData["currentButton"] = { ...newButton };
    }

    menuData["tab"] = this.tab;
    menuData["defaultRow"] = this.defaultRow;
    menuData["defaultButton"] = this.defaultButton;
    menuData["max_buttons"] = this.max_buttons;
    menuData["menu"] = this.current_menu;
    menuData["module"] = this.tab.module;
    menuData["mode"] = this.mode;
    menuData["menuList"] = this.menuList;
    menuData["sortedMenuList"] = this.sortedMenuList;
    menuData ["colors"] = this.colors;
    menuData ["light"] = this.light;

    // if (this.tab.module == TabNames.SPLASH) {
    //   this.mdw.changeTab({ tab: { module: this.module,}, menu: this.menu, row: this.row, button: this.button }, this.mode, true, false, true);
    // } else {
    //   this.mdw.changeTab({ tab: { module: this.module, menu_id: this.menu.menu_id }, menu: this.menu }, this.mode, true, false, true);
    // }

    // let tabData = {current_tab:{module: this.module}, menu:this.menu}

    this.mdw._currentMenuContainer.next(menuData);
  }

  ngOnDestroy(): void {
    // console.log("destroy");
    if (this.currentMenuSubscription) {
      this.currentMenuSubscription.unsubscribe();
    }
  }
  menuTrackBy(index, menu){
    return menu.menu_version;
 }

}
